import { render, staticRenderFns } from "./user-behavior.vue?vue&type=template&id=4df5d24b&scoped=true"
import script from "./user-behavior.vue?vue&type=script&lang=js"
export * from "./user-behavior.vue?vue&type=script&lang=js"
import style0 from "./user-behavior.vue?vue&type=style&index=0&id=4df5d24b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df5d24b",
  null
  
)

export default component.exports